import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const ResearchNotificationsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Ricerca Registrazioni SC - Anagrafe',
    path: '/notifiche-da-stato-civile',
  },
];

export const DetailNotificationsCrumbs = [
  ...ResearchNotificationsCrumbs,
  {
    name: 'Dettaglio Registrazioni SC - Anagrafe',
    path: '/notifiche-da-stato-civile/visualizza/:id/:idNotifica',
  },
];

export const EditNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...ResearchNotificationsCrumbs,
    {
      name: 'Modifica Registrazioni SC - Anagrafe',
      path: goBackUrl,
    },
  ];
};

export const BirthNotificationsNonResidentCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Registrazione Nascita Non Residenti',
      path: `${goBackUrl}/nascita/non-residenti`,
    },
  ];
};

export const CivilUnionNotificationsResidentCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsResidentCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile',
      path: `${goBackUrl}/unione-civile/residenti/registrazione`,
    },
  ];
};

export const CivilUnionNotificationsNonResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/unione-civile/non-residenti`,
    },
  ];
};

export const CivilUnionDetailNotificationsNonResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CivilUnionNotificationsNonResidentCrumbs(goBackUrl),
    {
      name: 'Registrazione Unione Civile Non Residenti',
      path: `${goBackUrl}/unione-civile/non-residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsResidentCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/matrimonio/residenti`,
    },
  ];
};

export const MarriageDetailNotificationsResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsResidentCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio',
      path: `${goBackUrl}/matrimonio/residenti/registrazione`,
    },
  ];
};

export const MarriageNotificationsNonResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona',
      path: `${goBackUrl}/matrimonio/non-residenti`,
    },
  ];
};

export const MarriageDetailNotificationsNonResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...MarriageNotificationsNonResidentCrumbs(goBackUrl),
    {
      name: 'Registrazione Matrimonio Non Residenti',
      path: `${goBackUrl}/matrimonio/non-residenti/registrazione`,
    },
  ];
};

export const DeathNotificationsResidentCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/residenti`,
    },
  ];
};

export const DeathCancellationNotificationsResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsResidentCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/residenti/cancellazione`,
    },
  ];
};

export const DeathNotificationsNonResidentCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/morte/non-residenti`,
    },
  ];
};

export const DeathCancellationNotificationsNonResidentCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...DeathNotificationsNonResidentCrumbs(goBackUrl),
    {
      name: 'Cancellazione',
      path: `${goBackUrl}/morte/non-residenti/cancellazione`,
    },
  ];
};

export const CitizenshipNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/cittadinanza/ricerca`,
    },
  ];
};

export const CitizenshipRegistrationNotificationsCrumbs = (
  goBackUrl: string
): Array<BreadcrumbItem> => {
  return [
    ...CitizenshipNotificationsCrumbs(goBackUrl),
    {
      name: 'Registrazione',
      path: `${goBackUrl}/cittadinanza/ricerca/registrazione`,
    },
  ];
};

export const FamilyNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia`,
    },
  ];
};

export const FamilyOtherNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/altra`,
    },
  ];
};

export const FamilyMotherNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/madre`,
    },
  ];
};

export const FamilyFatherNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Persona ',
      path: `${goBackUrl}/famiglia/padre`,
    },
  ];
};

export const FamilyDetailNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...FamilyNotificationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyOtherDetailNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...FamilyOtherNotificationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyMotherDetailNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...FamilyMotherNotificationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const FamilyFatherDetailNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...FamilyFatherNotificationsCrumbs(goBackUrl),
    {
      name: 'Iscrizione Famiglia',
      path: '/notifiche-da-stato-civile/modifica/:id/:idNotifica/famiglia/dettaglio',
    },
  ];
};

export const CohabitationNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...EditNotificationsCrumbs(goBackUrl),
    {
      name: 'Ricerca Convivenza',
      path: `${goBackUrl}/convivenza`,
    },
  ];
};

export const CohabitationDetailNotificationsCrumbs = (goBackUrl: string): Array<BreadcrumbItem> => {
  return [
    ...CohabitationNotificationsCrumbs(goBackUrl),
    {
      name: 'Nascita Convivenza',
      path: `${goBackUrl}/convivenza/nascita`,
    },
  ];
};
